import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import Marquee from "react-fast-marquee";

const EASE = [0.16, 1, 0.3, 1];

export const KineticLines = ({ lines, className = "", lineClassName = "", delay = 0 }) => (
  <span className={`block ${className}`} data-testid="kinetic-lines">
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
        <motion.span
          className={`block ${Array.isArray(lineClassName) ? lineClassName[i] : lineClassName}`}
          initial={{ y: "115%" }}
          animate={{ y: 0 }}
          transition={{ duration: 1.1, delay: delay + i * 0.14, ease: EASE }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

export const Reveal = ({ children, delay = 0, y = 48, className = "", testId }) => (
  <motion.div
    data-testid={testId}
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 1, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const ParallaxImage = ({ src, alt = "", className = "", imgClassName = "", testId, parallax = true, shiftX }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);
  return (
    <div ref={ref} className={`overflow-hidden ${className}`} data-testid={testId}>
      <motion.img
        src={src}
        alt={alt}
        style={parallax ? { y, scale: 1.18, x: shiftX } : shiftX ? { x: shiftX } : undefined}
        className={`h-full object-cover ${imgClassName || "w-full"}`}
      />
    </div>
  );
};

export const MarqueeRibbon = ({ items }) => (
  <div className="overflow-hidden border-y border-white/10 py-7" data-testid="marquee-ribbon" aria-hidden="true">
    <Marquee speed={25} gradient={false}>
      {[...items, ...items].map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="font-tech text-xl uppercase tracking-[0.35em] text-white/60">{item}</span>
          <span className="mx-10 inline-block h-2 w-2 rotate-45 bg-[#4A7BA6]" />
        </span>
      ))}
    </Marquee>
  </div>
);

export const Eyebrow = ({ children }) => (
  <p className="font-tech text-xs uppercase tracking-[0.4em] text-[#4A7BA6]">{children}</p>
);

export const FramedPhoto = ({ src, alt = "", caption, className = "", imgClassName = "", testId }) => (
  <figure className={className} data-testid={testId}>
    <div className="border border-white/15 bg-white p-2 shadow-[0_30px_80px_rgba(0,0,0,0.55)] sm:p-3">
      <img src={src} alt={alt} className={`w-full object-cover ${imgClassName}`} />
    </div>
    {caption && (
      <figcaption className="mt-5 font-tech text-[10px] uppercase tracking-[0.35em] text-white/40">
        {caption}
      </figcaption>
    )}
  </figure>
);
